module.exports = __webpack_public_path__ + "assets/homepage-arrow-db6552.svg";